import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Fixes a critical bug: previously a route only checked "are you logged
// in", never "are you allowed to see THIS page". A collector with every
// permission switched off in the Users screen could still open
// /customers, /loans, /accounts, etc. directly by URL and see everything.
//
// perm: the permission key this route requires (see PERMISSION_KEYS in
//   AuthContext). Pass null/undefined for admin-only routes that have no
//   corresponding permission toggle (e.g. P&L, which only admins can see).
export default function RequirePermission({ perm, adminOnly, children }) {
  const { user, hasPermission, permissionsLoaded } = useAuth();

  if (!permissionsLoaded) {
    return React.createElement('div', { style: { padding: 40, textAlign: 'center', color: '#6b7280' } }, 'Loading...');
  }

  var allowed = adminOnly ? (user && user.role === 'admin') : hasPermission(perm);

  if (!allowed) {
    var fallback = (user && user.role === 'collector') ? '/collections' : '/dashboard';
    // Avoid an infinite redirect loop on the rare case a collector has been
    // denied every single page (including Collections) — show a plain
    // message instead of bouncing forever.
    if (perm === 'collections' || (fallback === '/collections' && !hasPermission('collections'))) {
      return React.createElement('div', { style: { padding: 40, textAlign: 'center', color: '#6b7280' } },
        React.createElement('h3', null, 'No access'),
        React.createElement('p', null, "You don't have permission to view any pages yet. Ask an admin to enable access in Users.")
      );
    }
    return React.createElement(Navigate, { to: fallback, replace: true });
  }

  return children;
}
